import { GridProps } from "@sinecycle/growcomponents";

export const defaultColumnDefs: GridProps<any>["defaultColDef"] = {
  resizable: true,
  sortable: true,
  autoHeight: true,
  minWidth: 140,
};
